function noop() {}

export default (typeof window !== "undefined" ? require("./transport.js").default : noop);
